import React from 'react';

import GenericField from './shared/GenericField';
import NumberInputContainer from './number/NumberInputContainer';

/**
 * Number field input.
 * @param {string} [label] Label description for field input.
 * @param {number} [initialValue] Field value.
 * @param {function} [handleSave] [async number=>{bool success, string message}] Save changes / return error message.
 * @param {boolean} [isInt] Validates that the user has entered a number without decimals.
 * @param {boolean} [isPercentage] Validates that 0 <= value <= 100 before saving.
 */
const Number = ({ label, initialValue, handleSave: syncChanges, isCurrency, isInt, isPercentage }) => {
    if (initialValue !== null && isNaN(initialValue)) {
        //throw new Error(`Initial value '${initialValue}' must be a number`);
    }

    return (
        <GenericField>
            {label}
            <NumberInputContainer
                {...{
                    initialValue,
                    syncChanges,
                    isCurrency,
                    isInt,
                    isPercentage,
                }}
            />
        </GenericField>
    );
};

export default Number;
